import {
  Component,
  OnInit,
  OnDestroy,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';
import { SupplierException } from 'src/app/shared/models/supplier-exception';
import { StoreService } from 'src/app/shared/services/store-service/store.service';

@Component({
  standalone: false,
  selector: 'exception-table',
  templateUrl: './exception-table.component.html',
  styleUrls: ['./exception-table.component.scss'],
})
export class ExceptionTableComponent implements OnInit, OnDestroy {
  @Input() isViewOnly: boolean = false;
  @Input() exceptions: SupplierException[] = [];
  @Input() error: { [id: number]: string } = {};
  @Output() saveException = new EventEmitter<SupplierException[]>();
  @Output() cancelException = new EventEmitter<SupplierException[]>();
  @Output() validateSupplierProfile = new EventEmitter<SupplierException[]>();

  originalException: SupplierException[] = [];

  constructor(public storeService: StoreService) {}

  async ngOnInit(): Promise<void> {
    if (!this.exceptions) {
      this.exceptions = new Array<SupplierException>();
    }

    if (this.exceptions) {
      this.addExceptionID();
      this.originalException = JSON.parse(JSON.stringify(this.exceptions));
    }

    this.addNewException();
  }

  async ngOnDestroy(): Promise<void> {
    this.exceptions = JSON.parse(JSON.stringify(this.originalException));
    this.cancelException.emit(this.exceptions);
  }

  handleUpdateException(exception: SupplierException) {
    this.exceptions.forEach((item) => {
      if (item.id === exception.id) {
        item = exception;
      }
    });

    // Check duplicate exception when user selected (new)
    if (this.checkDuplicateException(exception)) {
      alert(
        'Cannot add duplicate exception criteria: ' + exception.criteria + '!'
      );
    }

    this.addNewException();
  }

  checkDuplicateException(exception: SupplierException): boolean {
    let found = false;
    if (exception.criteria === 'Material Exclusion') return false;

    this.exceptions.forEach((item) => {
      if (
        item.criteria === exception.criteria &&
        item.id !== exception.id &&
        item.isDeleted === false
      ) {
        exception.isDeleted = true;
        found = true;
        return;
      }
    });
    return found;
  }

  handleDeleteException(exception: SupplierException) {
    if (exception.criteria.localeCompare('New') !== 0) {
      this.exceptions.forEach((item, index) => {
        if (item.id === exception.id) {
          this.exceptions.splice(index, 1);
        }
      });
    }
  }

  handleSelectedValueChange(id: number) {
    if (this.error !== null) {
      this.error[id] = '';
    }
  }

  addExceptionID() {
    if (!this.exceptions) return;

    this.exceptions.forEach((item, index) => {
      item.id = index;
    });
  }

  addNewException() {
    // Do not add in view mode
    if (this.isViewOnly) return;

    // Check if new entry already exist
    if (
      this.exceptions &&
      this.exceptions.find((line) => line.criteria == 'New')
    )
      return;

    // Prepare new exception
    var newException = <SupplierException>{
      criteria: 'New',
      value: 'New',
      isDeleted: false,
    };

    // Add new exception
    if (this.exceptions) {
      newException.id = this.exceptions.length;
    } else {
      newException.id = 0;
    }

    // Add new exception
    this.exceptions.push(newException);
  }

  removeNewException(exceptions: SupplierException[]) {
    return exceptions.filter((item) => {
      return item.criteria == 'New';
    });
  }

  onSave() {
    var filterNew = this.exceptions.filter((item) => !(item.criteria == 'New'));

    this.error = {};
    filterNew.filter((mat) => {
      if (mat.criteria === 'Material Exclusion') {
        if (
          this.storeService.materials.filter((existMat) => {
            return existMat.MARA_MATNR_MaterialNumber == mat.value;
          }).length == 0
        ) {
          this.error[mat.id ?? 0] = 'Material not existing';
        }
      }
    });

    if (
      Object.keys(this.error)
        .map((key) => {
          return !Boolean(this.error[Number(key)]);
        })
        .every((i) => i)
    ) {
      this.originalException = JSON.parse(JSON.stringify(filterNew));
      this.saveException.emit(filterNew);
    } else {
      this.validateSupplierProfile.emit(filterNew);
    }
  }

  onCancel() {
    this.exceptions = JSON.parse(JSON.stringify(this.originalException));
    this.isViewOnly = !this.isViewOnly;
  }

  toggleEditMode() {
    this.isViewOnly = !this.isViewOnly;
    this.addNewException();
  }
}

